<template>
	<!-- BEGIN login -->
	<div class="login login-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image" style="background-image: url(/assets/img/login-bg/login-bg-13.jpg)"></div>
			<div class="news-caption">
				<h4 class="caption-title" v-html="siteName"></h4>
				<p>
					Здесь вы можете получить живых подписчиков и лайки во всех соц. сетях, поднять посещаемость вашего
					сайта, раскрутить любой ваш проект или набрать
					рефералов на другие проекты. Только живой трафик, быстрое и
					качественное выполнение ваших заказов.
				</p>
			</div>
		</div>
		<!-- END news-feed -->

		<!-- BEGIN login-container -->
		<div class="login-container">
			<!-- BEGIN login-header -->
			<div class="login-header mb-30px">
				<div class="brand">
					<div class="d-flex align-items-center">
						<span v-html="siteName"></span>
					</div>
					<small>Биржа простых задач</small>
				</div>
				<div class="icon">
					<i class="fa fa-sign-in-alt"></i>
				</div>
			</div>
			<!-- END login-header -->

			<!-- BEGIN login-content -->
			<div class="login-content">
				<div v-if="token" class="text-center pt-1">
					<div class="alert alert-primary fade show">
						Емаил подтвержден<br> <a type="button" href="/" class="btn btn-primary btn-sm  mt-3">Ok</a>
					</div>
				</div>
				<div v-else class="text-center">
					<div class="alert alert-primary fade show">
						Время действия ссылки истекло.<br>Попробуйте отправить письмо раз.<br><a type="button"
							href="/#/forgot-password" class="btn btn-primary btn-sm mt-3">Ok</a>
					</div>
				</div>
			</div>
			<!-- END login-content -->
		</div>
		<!-- END login-container -->
	</div>
	<!-- END login -->
</template>

<script>
import AppOptions from '../config/AppOptions.vue'
import HTTP from "../http";
import { show_error } from "../message";


export default {
	data() {
		return {
			token: null,
			loading: false,
			errors: null,
			siteName: ''
		};
	},

	created() {
		AppOptions.appEmpty = true;
		this.siteName = process.env.VUE_APP_SITE_NAME
		this.checkSignature(this.$route.query.signature, this.$route.params.email);
	},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	},
	methods: {
		checkSignature(signature, email) {
			this.$insProgress.start();
			this.loading = true;
			HTTP()
				.get("email-confirm/" + email + '?signature=' + signature)
				.then((resp) => {
					this.token = resp.data
					console.log('resp', resp)
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
				})
		},
	},
}
</script>